import { Component } from "react";
import { connect } from "react-redux";
import Agreement from "../../../components/Client/agreement_new";

import { addSettings } from "../../../actions";
import {
  getClientForm,
  saveClientResponse,
  saveClientResponseDraft,
} from "../../../config/forms_api_calls";
import {
  save_onboarding_for_specific_user,
  profileUpdate as clientProfileUpdate,
} from "../../../config/client_api_calls";
import $ from "jquery";

import DataTableExtended from "../../../components/Tables/DataTableExtended";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import Typography from "@material-ui/core/Typography";
import FormRendererClient from "../../../components/Client/formRenderClient";
import NotificationToast from "../../../components/Notification/NotificationToast";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "../../../config/helperClass";
import dateFormat from "dateformat";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import axios from "axios";
import TextField from "../../../components/InputFields/TextField";
import PasswordStrengthBar from "react-password-strength-bar";
import { Tooltip, Button } from "@material-ui/core";
import Select from "react-select";
import countryList from "react-select-country-list";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { PhoneInput } from "react-international-phone";
import MutextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import PhoneInput2 from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
const auth = new HelperClass();

class OnboardingContent extends Component {
  // Track the current API request to prevent race conditions
  currentRequestId = null;

  constructor() {
    super();

    this.state = {
      toastMessage: "",
      toastType: "success",
      toastTitle: "",
      tableData: [],
      tableDataSingle: [],
      serviceData: [],
      tableLoaderListing: true,
      tableLoader: true,
      contentReady: false,
      errorMessage: "",
      successMessage: "",
      showModal: false,
      modalContent: null,
      formAccNo: "",
      successMessageSaveResponse: "",
      errorMessageSaveResponse: "",
      form_accountno: "",
      form_token: "",
      formData: "",
      form_title: "",
      form_desc: "",
      client_details: [],
      form_submitted: "3",
      allow_multiple: 0,
      responseMessage: "",
      allow_submit: 1,
      link_form: false,
      captcha_enabled: 0,
      external_link: "",
      draftData: [],
      submittedData: [],
      progressStep: 0,
      totalSteps: 0,
      chatgpt_intergation: "No",
      conversational_ai: "No",
      chatgpt_api_key: "",
      isStoppingAgent: false,
      allow_agent_name: false,
      isCurrentStepFilled: false,
      isOnboarding: true,
      isFilled: 0,
      isSkipped: 0,
      // Profile data for step 0 view
      profileData: null,
      showViewProfileModal: false,
      // Profile form state for editing (full version)
      profile_comp_name: "",
      profile_name: "",
      profile_title: "",
      profile_email: "",
      profile_phone: "",
      profile_address: "",
      profile_address2: "",
      profile_city: "",
      profile_state: "",
      profile_zip: "",
      profile_country: "United States",
      profile_password: "",
      profile_confirm_password: "",
      profilePasswordShown: false,
      profileConfirmPasswordShown: false,
      profileDisabled: false,
      profileErrorMessage: "",
      profileSuccessMessage: "",
      // Address autocomplete settings
      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",
      address_autocomplete: "Yes",
      address_validation: true,
      countryOptions: countryList()
        .getData()
        .map((country) => {
          return { label: country.label, value: country.value };
        }),
    };
  }

  getFormTokenFromStepsData = () => {
    let form_token = this.props.props?.match?.params?.form_token;

    // If form_token is not in URL params, try to get it from the current step in stepsData
    if (
      !form_token &&
      this.props.stepsData &&
      this.props.stepsData.length > 0
    ) {
      const currentStepIndex = this.props.currentStep; // currentStep is 0-indexed (from sidebar)
      if (
        currentStepIndex >= 0 &&
        currentStepIndex < this.props.stepsData.length
      ) {
        const currentStep = this.props.stepsData[currentStepIndex];
        // console.log("Current step data:", currentStep);
        if (currentStep.type === "form" && currentStep.formToken) {
          form_token = currentStep.formToken;
          // console.log("Found formToken:", form_token);
        }
      }
    }

    return form_token;
  };

  getFormFromStepsData = () => {
    let form = null;

    // console.log(
    //   "🔍 getFormFromStepsData called. stepsData:",
    //   this.props.stepsData,
    //   "currentStep:",
    //   this.props.currentStep,
    // );

    // Get form from the current step in stepsData
    if (
      this.props.stepsData &&
      this.props.stepsData.length > 0 &&
      this.props.currentStep >= 0
    ) {
      const currentStepIndex = this.props.currentStep; // currentStep is 0-indexed (from sidebar)
      if (
        currentStepIndex >= 0 &&
        currentStepIndex < this.props.stepsData.length
      ) {
        const currentStep = this.props.stepsData[currentStepIndex];
        // console.log("✅ Current Step found:", currentStep);
        if (currentStep && currentStep.form) {
          form = currentStep.form;
          // console.log("✅ form extracted from step:", form);
        } else {
          // console.log("❌ No form in current step");
        }
      }
    } else {
      // console.log(
      //   "❌ stepsData or currentStep missing. stepsData:",
      //   !!this.props.stepsData,
      //   "currentStep:",
      //   this.props.currentStep,
      // );
    }

    return form;
  };

  async loadForm() {
    // Use the formToken prop directly from sidebar (PRIORITY)
    let form_token = this.props.formToken;
    let form_object = this.props.form || this.getFormFromStepsData(); // Get form object from sidebar prop (PRIORITY)

    // console.log(
    //   "📋 loadForm() - Initial values. form_token:",
    //   form_token,
    //   "form_object from sidebar:",
    //   form_object,
    // );

    // Fallback to getting from stepsData if prop not provided
    if (!form_token) {
      form_token = this.getFormTokenFromStepsData();
      // console.log(
      //   "⚠️ form_token not from props, got from stepper:",
      //   form_token,
      // );
    }

    // If still no token, check if this is a basic or agreement step (which don't need form tokens)
    if (!form_token) {
      const currentStepData =
        this.props.stepsData &&
        this.props.stepsData[this.props.currentStep]; // currentStep is 0-indexed (from sidebar)
      const stepType = currentStepData?.type;

      if (stepType === "basic" || stepType === "agreement") {
        // console.log(
        //   "✅ Step type",
        //   stepType,
        //   "doesn't require formToken, skipping form load",
        // );
        // Update isFilled and isSkipped from step data for basic and agreement steps
        const isFilled = currentStepData?.isFilled || 0;
        const isSkipped = currentStepData?.isSkipped || 0;
        this.setState({
          tableLoader: false,
          isFilled: isFilled,
          isSkipped: isSkipped,
          form_token: "", // Clear formToken for steps 0 and 1
          formData: "", // Clear formData for steps 0 and 1
        }, () => {
          if (stepType === "basic") {
            this.extractAndDisplayProfileData();
            setTimeout(() => this.setState({ contentReady: true }), 150);
          }
          // For "agreement" steps, contentReady is set via onAgreementReady once
          // Agreement's own API call finishes and its state is fully applied.
        });
        return;
      }

      // console.log("❌ No form_token available for step type:", stepType);
      this.setState({
        mainError:
          "Form token is missing. Please access this page with a valid form token.",
        tableLoader: false,
      });
      return;
    }

    // Get account number from form account number prop (from stepper), form object, or use fallback
    let form_accountno =
      this.props.formAccountNo ||
      form_object?.account_no ||
      this.props.clientAccountNo ||
      auth.getAccount();
    // console.log(
    //   "✅ form_accountno - formAccountNo prop:",
    //   this.props.formAccountNo,
    //   "form_object.account_no:",
    //   form_object?.account_no,
    //   "clientAccountNo:",
    //   this.props.clientAccountNo,
    //   "auth.getAccount():",
    //   auth.getAccount(),
    //   "Final:",
    //   form_accountno,
    // );

    this.setState({
      formAccNo: form_accountno || "",
      form_token: form_token,
    });

    // Log the exact payload being sent
    let accountno = this.props.clientAccountNo || auth.getAccount();
    // console.log("📤 API Payload:", {
    //   accountno: accountno,
    //   api_accountno: accountno,
    //   form_accountno: form_accountno,
    //   form_token: form_token,
    //   token: auth.getClientToken(),
    // });

    // Generate unique request ID to prevent race conditions
    const requestId = Math.random();
    this.currentRequestId = requestId;

    try {
      const servicesResponce = await getClientForm(
        accountno,
        auth.getClientToken(),
        form_accountno,
        form_token,
      );

      // Only process response if this is still the current request
      if (this.currentRequestId !== requestId) {
        // console.log(
        //   "⚠️ Stale request response ignored (newer request in progress)",
        // );
        return;
      }

      // console.log("getClientForm: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      } else if (servicesResponce.data.status === 404) {
        // Form not found - handle with error message and auto-navigation
        this.handleFormUnavailableError();
      } else if (servicesResponce.data.status === 200) {
        let from_table = servicesResponce.data.from_table;
        const groupsData = servicesResponce.data.data[0]["groups"];
        const groups = groupsData ? JSON.parse(groupsData) : [];

        //const draftResponse = servicesResponce.data.client_data[0]["response"];
        const draftResponse = servicesResponce.data.draft_response;
        const draftData =
          draftResponse && draftResponse !== ""
            ? JSON.parse(draftResponse)
            : [];

        // Get submitted response data - try multiple locations
        let submittedResponse = servicesResponce.data.submitted_response;

        // If not found at top level, try in data array
        if (
          !submittedResponse &&
          servicesResponce.data.data &&
          servicesResponce.data.data[0]
        ) {
          submittedResponse = servicesResponce.data.data[0]["response"];
        }

        // If still not found, try in client_data
        if (
          !submittedResponse &&
          servicesResponce.data.client_data &&
          servicesResponce.data.client_data[0]
        ) {
          submittedResponse = servicesResponce.data.client_data[0]["response"];
        }

        let submittedData = [];
        if (submittedResponse && submittedResponse !== "") {
          try {
            const parsedData = JSON.parse(submittedResponse);
            // Ensure submittedData is in the format [{ questions: [...] }]
            submittedData = Array.isArray(parsedData)
              ? parsedData
              : [parsedData];
          } catch (e) {
            console.error("Error parsing submittedResponse:", e);
            submittedData = [];
          }
        }

        // console.log(
        //   "📋 Debug - API Response keys:",
        //   Object.keys(servicesResponce.data),
        // );
        // console.log(
        //   "📋 Debug - draftData:",
        //   draftData,
        //   "submittedData:",
        //   submittedData,
        // );

        //const progress = servicesResponce.data.data[0]["progress"];

        let progress = "";
        if (from_table === "submission") {
          progress = servicesResponce.data.progress;
        }
        let progressStep = 0;
        if (progress) {
          const [current, total] = progress.split("/").map(Number);
          progressStep = current < total ? current : 0;
        }

        let form_submitted = 0;
        let allow_multiple = 0;
        if (from_table === "main") {
          form_submitted = servicesResponce.data.client_data[0]["is_filled"];
          allow_multiple =
            servicesResponce.data.client_data[0]["allow_multiple"];
        } else {
          // Check is_filled first (priority), then fall back to is_submitted
          const is_filled = servicesResponce.data.data[0]["is_filled"];
          if (is_filled === 1) {
            form_submitted = "Yes";
          } else if (
            is_filled === 0 ||
            servicesResponce.data.is_submitted === 0
          ) {
            // If isFilled is explicitly 0, or is_submitted is 0, show as "No"
            form_submitted = "No";
          } else if (servicesResponce.data.is_submitted === 1) {
            form_submitted = "Yes";
          }

          allow_multiple = servicesResponce.data.data[0]["allow_multiple"];
        }

        let chatgpt_intergation = "No";
        let conversational_ai = "No";
        let chatgpt_api_key = "";

        if (
          servicesResponce.data.integrationInfo &&
          servicesResponce.data.integrationInfo.length > 0
        ) {
          for (
            let i = 0;
            i < servicesResponce.data.integrationInfo.length;
            i++
          ) {
            const item = servicesResponce.data.integrationInfo[i];
            if (
              item["integration_type"] === "chatgpt" &&
              item["active"] === 1 &&
              item["enabled"] === "Yes"
            ) {
              chatgpt_intergation = "Yes";
              if (item["api_key"]) {
                chatgpt_api_key = this.decryptApiKey(item["api_key"]);
              }
            }

            if (
              item["integration_type"] === "conversational" &&
              item["active"] === 1 &&
              item["enabled"] === "Yes"
            ) {
              conversational_ai = "Yes";
            }
          }
        }

        const aiAgentCreation =
          servicesResponce.data.data[0]["ai_agent_creation"] === 1;
        const aiAgentLink =
          servicesResponce.data.data[0]["ai_agent_creation_external_link"];

        const allow_agent_name = aiAgentCreation && aiAgentLink ? true : false;

        // Get isFilled and isSkipped from API response
        let isFilled = 0;
        let isSkipped = 0;
        if (from_table === "main") {
          isFilled = servicesResponce.data.client_data[0]["is_filled"] || 0;
          isSkipped = servicesResponce.data.client_data[0]["is_skipped"] || 0;
        } else {
          isFilled = servicesResponce.data.data[0]["is_filled"] || 0;
          isSkipped = servicesResponce.data.data[0]["is_skipped"] || 0;
        }

        // In onboarding mode, override with step's isFilled and isSkipped status from stepsData
        if (
          this.state.isOnboarding &&
          this.props.stepsData &&
          this.props.stepsData.length > 0 &&
          this.props.currentStep >= 0
        ) {
          const currentStepData = this.props.stepsData[this.props.currentStep];
          if (currentStepData) {
            if (
              currentStepData.isSkipped === 1 ||
              currentStepData.isSkipped === true
            ) {
              // console.log(
              //   "📋 Onboarding mode: Step is skipped, allowing re-editing - forcing isFilled to 0",
              // );
              isSkipped = 1;
              isFilled = 0; // Force isFilled to 0 so the form always renders for skipped steps
            } else if (currentStepData.isFilled === 1) {
              // console.log(
              //   "📋 Onboarding mode: Using step's isFilled status:",
              //   currentStepData.isFilled,
              //   "instead of form's is_filled:",
              //   isFilled,
              // );
              isFilled = 1;
            }
          }
        }

        const countryOptions = countryList()
          .getData()
          .map((country) => {
            return { label: country.label, value: country.value };
          });

        this.setState(
          {
            formData: servicesResponce.data.data[0]["form_content"],
            form_title: servicesResponce.data.data[0]["form_title"],
            form_desc: servicesResponce.data.data[0]["form_desc"],
            allow_submit:
              isFilled === 1
                ? 0
                : servicesResponce.data.data[0]["allow_submit"],
            link_form: servicesResponce.data.data[0]["link_form"],
            captcha_enabled: servicesResponce.data.data[0]["captcha_enabled"] || 0,
            external_link: servicesResponce.data.data[0]["external_link"],
            groups: groups,
            client_details: servicesResponce.data.client_details,
            form_submitted: form_submitted,
            allow_multiple: allow_multiple,
            draftData: draftData,
            submittedData: submittedData,
            progressStep: progressStep,
            totalSteps: groups.length,
            tableLoader: false,
            tableLoaderListing: false,
            chatgpt_intergation: chatgpt_intergation,
            chatgpt_api_key: chatgpt_api_key,
            conversational_ai: conversational_ai,
            allow_agent_name: allow_agent_name,
            isFilled: isFilled,
            isSkipped: isSkipped,
            countryOptions: countryOptions,
          },
          () => {
            // Extract profile data after state is updated
            this.extractAndDisplayProfileData();
            setTimeout(() => this.setState({ contentReady: true }), 150);
          },
        );

        // console.log("📊 Form loaded with:", {
        //   progressStep: progressStep,
        //   totalSteps: groups.length,
        //   progress: progress,
        //   formToken: form_token,
        //   currentStep: this.props.currentStep,
        //   isLastStep: this.isLastStep(),
        // });
      } else {
        this.setState({
          tableLoader: false,
          tableLoaderListing: false,
          contentReady: true,
          form_submitted: "3",
          errorMessage: "Failed to load form. Please try again.",
        });
      }
    } catch (error) {
      // Only handle error if this is still the current request
      if (this.currentRequestId !== requestId) {
        // console.log("⚠️ Stale error ignored (newer request in progress)");
        return;
      }

      console.error("❌ Error loading form:", error);
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
        contentReady: true,
        errorMessage:
          "An error occurred while loading the form. Please try again.",
      });
    }
  }

  componentDidUpdate(prevProps) {
    // Onboarding is finishing (last step done, reload pending) — freeze on the
    // completion screen instead of flashing a loader when stepsData mutates.
    if (this.state.onboardingCompleting) {
      return;
    }

    // A real navigation is a change of step/form. A stepsData-only change
    // (e.g. marking the current step filled after signing the last agreement)
    // must NOT wipe content and show a loader.
    const navChanged =
      this.props.formToken !== prevProps.formToken ||
      this.props.formAccountNo !== prevProps.formAccountNo ||
      this.props.currentStep !== prevProps.currentStep;
    const stepsDataChanged = this.props.stepsData !== prevProps.stepsData;

    if (!navChanged && !stepsDataChanged) {
      return;
    }

    if (!navChanged && stepsDataChanged) {
      // Same step, its metadata updated — refresh filled status only.
      this.updateCurrentStepFilledStatus();
      return;
    }

    // console.log("🔄 Step changed - immediately clearing old form state");

    // Agreement and basic steps don't fetch a form — skip the full-page
    // loader for them (the agreement branch has its own contentReady overlay,
    // which resolves near-instantly from the session cache). Form steps keep
    // the loader while getClientForm runs.
    const nextStepData =
      (this.props.stepsData && this.props.stepsData[this.props.currentStep]) ||
      this.props.agreementData ||
      {};
    const nextType = nextStepData.type;
    const needsFullLoader = nextType !== "agreement" && nextType !== "basic";

    // CRITICAL: Immediately clear old form and show loader
    // This prevents showing stale form data while new one loads
    this.setState(
      {
        formData: "", // Clear previous form data immediately
        tableLoader: needsFullLoader,
        contentReady: false,
        errorMessage: "", // Clear previous errors
        responseMessage: "",
        errorMessageSaveResponse: "",
        successMessageSaveResponse: "",
        progressStep: 0,
        isFilled: 0,
        isSkipped: 0,
      },
      () => {
        // After state is cleared, handle step-specific pre-loading
        if (this.props.currentStep === 0) {
          // console.log("⚡ Pre-loading profile data for step 0");
          this.extractAndDisplayProfileData();
        }

        // Load new form asynchronously
        this.loadForm();
        this.updateCurrentStepFilledStatus();
        // Re-check scroll state when switching to an agreement step
        this.triggerAgreementScrollCheck();
      },
    );
  }

  componentWillUnmount() {
    // Prevent the safety-net reload from firing after the gate flip unmounts us.
    clearTimeout(this._completionFallback);
    clearTimeout(this._completionTimer);
  }

  // Final step done: show the completion card, then flip the onboarding gate in
  // place (no full reload → no reappearance of the onboarding view). A delayed
  // hard reload is kept only as a safety net if the gate somehow doesn't flip.
  finishOnboarding = () => {
    this.setState({ onboardingCompleting: true });
    this._completionTimer = setTimeout(() => {
      if (this.props.onOnboardingComplete) {
        this.props.onOnboardingComplete();
      } else {
        window.location.reload();
      }
    }, 1200);
    this._completionFallback = setTimeout(() => {
      window.location.reload();
    }, 6000);
  };

  // Clean completion screen shown after the final step is done, while the
  // brief redirect into the portal is pending — replaces the old loader flash.
  renderOnboardingComplete = () => (
    <div style={{ background: "#fff", border: "1px solid #e5e9f2", borderRadius: "12px", padding: "56px 24px", marginTop: "14px", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div style={{ width: "72px", height: "72px", borderRadius: "50%", background: "#eafaf1", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "20px" }}>
        <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#1ee0ac" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>
      </div>
      <h4 style={{ fontSize: "22px", fontWeight: 700, color: "#364a63", margin: 0 }}>
        Onboarding complete
      </h4>
      <div className="obs-skel" style={{ width: "160px", height: "6px", borderRadius: "999px", marginTop: "20px" }} />
    </div>
  );

  // Shimmer skeleton matching the loading step's real structure: agreements
  // get the two-column document + panel ghost, forms (and the basic profile
  // step) get a field-grid ghost.
  renderStepSkeleton = () => {
    const stepType =
      this.props.agreementData?.type ||
      (this.props.stepsData &&
        this.props.stepsData[this.props.currentStep] &&
        this.props.stepsData[this.props.currentStep].type);
    if (stepType === "agreement") {
      return this.renderAgreementSkeleton();
    }
    return this.renderFormSkeleton();
  };

  // Form-shaped skeleton: form title, a grid of label+input ghosts, a
  // textarea block and a submit button — mirrors FormRendererClient layout.
  renderFormSkeleton = () => (
    <div style={{ background: "#fff", border: "1px solid #e5e9f2", borderRadius: "12px", padding: "24px", marginTop: "14px" }}>
      <div className="obs-skel" style={{ width: "30%", height: "20px", marginBottom: "8px" }} />
      <div className="obs-skel" style={{ width: "52%", height: "12px", marginBottom: "26px" }} />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "18px 24px", marginBottom: "22px" }}>
        {[38, 46, 30, 42, 34, 44].map((w, i) => (
          <div key={i}>
            <div className="obs-skel" style={{ width: `${w}%`, height: "10px", marginBottom: "8px" }} />
            <div className="obs-skel" style={{ width: "100%", height: "44px", borderRadius: "8px" }} />
          </div>
        ))}
      </div>
      <div className="obs-skel" style={{ width: "34%", height: "10px", marginBottom: "8px" }} />
      <div className="obs-skel" style={{ width: "100%", height: "90px", borderRadius: "8px", marginBottom: "26px" }} />
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <div className="obs-skel" style={{ width: "140px", height: "44px", borderRadius: "8px" }} />
      </div>
    </div>
  );

  // Agreement-shaped skeleton: document card + side panel ghost.
  renderAgreementSkeleton = () => (
    <div className="row mx-0" style={{ display: "flex", alignItems: "stretch", marginTop: "14px" }}>
      {/* LEFT: document card skeleton */}
      <div className="col-lg-8 px-0 agr-doc-col" style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ background: "#fff", border: "1px solid #e5e9f2", borderRadius: "12px", overflow: "hidden", flex: 1 }}>
          <div style={{ padding: "20px 24px 16px", borderBottom: "1px solid #e5e9f2" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "14px" }}>
              <div className="obs-skel" style={{ width: "110px", height: "26px", borderRadius: "999px" }} />
              <div className="obs-skel" style={{ width: "104px", height: "32px", borderRadius: "8px", marginLeft: "auto" }} />
              <div className="obs-skel" style={{ width: "104px", height: "32px", borderRadius: "8px" }} />
            </div>
            <div className="obs-skel" style={{ width: "42%", height: "22px", marginBottom: "10px" }} />
            <div className="obs-skel" style={{ width: "28%", height: "12px" }} />
          </div>
          <div style={{ padding: "20px 24px 28px" }}>
            <div className="obs-skel" style={{ width: "100%", height: "64px", borderRadius: "12px", marginBottom: "22px" }} />
            {[92, 100, 97, 84, 100, 95, 68].map((w, i) => (
              <div key={i} className="obs-skel" style={{ width: `${w}%`, height: "12px", marginBottom: "12px" }} />
            ))}
            <div className="obs-skel" style={{ width: "40%", height: "12px" }} />
          </div>
        </div>
      </div>
      {/* RIGHT: side panel skeleton */}
      <div className="col-lg-4 px-0 agr-panel-col" style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ background: "#fff", border: "1px solid #e5e9f2", borderRadius: "12px", padding: "24px", flex: 1 }}>
          <div className="obs-skel" style={{ width: "92px", height: "24px", borderRadius: "999px", marginBottom: "14px" }} />
          <div className="obs-skel" style={{ width: "55%", height: "18px", marginBottom: "8px" }} />
          <div className="obs-skel" style={{ width: "78%", height: "12px", marginBottom: "22px" }} />
          <div className="obs-skel" style={{ width: "100%", height: "84px", borderRadius: "10px", marginBottom: "12px" }} />
          <div className="obs-skel" style={{ width: "100%", height: "84px", borderRadius: "10px", marginBottom: "12px" }} />
          <div className="obs-skel" style={{ width: "100%", height: "54px", borderRadius: "10px" }} />
        </div>
      </div>
    </div>
  );

  // After layout settles, tell the Agreement component to re-evaluate whether
  // content fits without scrolling (handles short agreements and large screens).
  triggerAgreementScrollCheck = () => {
    if (this.props.agreementData?.type === "agreement") {
      setTimeout(() => {
        if (this.agreementRef && typeof this.agreementRef.checkContentScrollable === "function") {
          this.agreementRef.checkContentScrollable();
        }
      }, 600);
    }
  };

  async componentDidMount() {
    // console.log("🔥 OnboardingContent mounted. Props:", {
    //   currentStep: this.props.currentStep,
    //   stepsDataLength: this.props.stepsData?.length,
    //   stepsData: this.props.stepsData,
    //   formToken: this.props.formToken,
    //   clientAccountNo: this.props.clientAccountNo,
    // });

    // For step 0 (Basic Information), pre-load profile data immediately for fast rendering
    if (this.props.currentStep === 0) {
      // console.log("⚡ Pre-loading profile data for step 0 (fast path)");
      this.extractAndDisplayProfileData();
    }

    await this.loadForm();
    this.triggerAgreementScrollCheck();
  }

  updateCurrentStepFilledStatus = () => {
    if (
      this.props.stepsData &&
      this.props.stepsData.length > 0 &&
      this.props.currentStep >= 0
    ) {
      const currentStepData = this.props.stepsData[this.props.currentStep];
      if (currentStepData && currentStepData.isFilled === 1) {
        // console.log(
        //   "⚠️ Current step is already filled. Submission disabled.",
        //   currentStepData.title,
        // );
        this.setState({
          isCurrentStepFilled: true,
          isFilled: 1, // Also update isFilled to show "Form Submitted" message
        });
        return;
      }
    }
    this.setState({
      isCurrentStepFilled: false,
      isFilled: 0, // Reset isFilled when navigating to unfilled step
    });
  };

  handleSkipStep = async () => {
    // For last step in onboarding, let the parent (OnboardingDashboard) handle it
    // to avoid duplicate API calls
    if (this.isLastStep() && this.state.isOnboarding) {
      // console.log(
      //   "🔄 Last step skip - delegating to parent (OnboardingDashboard)",
      // );
      // Call parent's onSkipStep which will handle the API call
      if (
        this.props.onSkipStep &&
        typeof this.props.onSkipStep === "function"
      ) {
        this.props.onSkipStep();
      }
      return;
    }

    // Normal skip behavior for non-last steps
    if (this.props.onSkipStep && typeof this.props.onSkipStep === "function") {
      this.props.onSkipStep();
    }
  };

  handleNextStep = async () => {
    // Navigate to the next step when form is filled and skipped
    if (
      this.props.onStepComplete &&
      typeof this.props.onStepComplete === "function"
    ) {
      this.props.onStepComplete();
    }
  };

  handleAgreementSigned = async () => {
    // Mirror the form submission flow: persist isFilled=1 in onboarding JSON, then advance stepper
    try {
      const response = await save_onboarding_for_specific_user(
        this.props.clientAccountNo,
        "client",
        this.props.stepTitle,
      );

      const isComplete = response?.data?.onboarding_status === "complete";

      if (this.props.onStepComplete && typeof this.props.onStepComplete === "function") {
        this.props.onStepComplete();
      }

      if (isComplete) {
        this.finishOnboarding();
      } else {
        // Success cue at the parent level — survives the instant step advance
        // (the agreement component's own toast unmounts with it).
        // this.showToast("Agreement signed successfully.", "success", "Agreement Signed");
      }
    } catch (error) {
      console.error("Error updating onboarding step after agreement signing:", error);
      if (this.props.onStepComplete && typeof this.props.onStepComplete === "function") {
        this.props.onStepComplete();
      }
    }
  };

  decryptApiKey = (encryptedValue) => {
    if (!encryptedValue || typeof encryptedValue !== "string") {
      console.error("decryptApiKey: Invalid encrypted value");
      return "";
    }

    try {
      const bytes = CryptoJS.AES.decrypt(
        encryptedValue,
        process.env.REACT_APP_SECRET_AES,
      );
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);

      if (!decrypted) {
        console.error("Decryption resulted in empty string");
        return "";
      }

      return decrypted;
    } catch (err) {
      console.error("Decryption failed:", err);
      return "";
    }
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy, h:MM:ss TT");
  };

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  openModal = (formData, formAccNo) => {
    const modalContent = (
      <FormRendererClient
        formData={JSON.parse(formData)}
        formTitle={this.state.form_title}
        onSubmit={this.handleSubmitForm}
        onToast={this.showToast}
        captcha_enabled={this.state.captcha_enabled}
        link_form={this.state.link_form}
        // id={this.state.forms[0].id}
        // setShowResponse={(value) => this.setState({ showResponse: value })}
      />
    );
    this.setState({ modalContent: modalContent, formAccNo: formAccNo }, () => {
      window.$("#modalPreviewForm").modal("show");
    });
  };

  closeModal = () => {
    this.setState({ modalContent: null, formAccNo: "" }, () => {
      window.$("#modalPreviewForm").modal("hide");
    });
  };

  handleFormUnavailableError = () => {
    this.setState({
      tableLoader: false,
      tableLoaderListing: false,
      form_submitted: "3",
      errorMessage: "Form unavailable. It may have expired or been removed.",
    });

    setTimeout(() => {
      this.handleSkipStep();
    }, 2000);
  };

  // countryList stores ISO-2 codes as value (e.g. "US") but the API/session
  // may return full names (e.g. "United States"). This normalises either format
  // to an ISO-2 code so the MUI Autocomplete can match it in countryOptions.
  normalizeCountry = (raw) => {
    if (!raw) return "US";
    const upper = raw.toUpperCase();
    // Already a 2-letter ISO code
    if (upper.length === 2 && this.state.countryOptions.find(c => c.value === upper)) {
      return upper;
    }
    // Full name — look it up via labelMap (label→ISO)
    const iso = countryList().getValue(raw);
    if (iso) return iso.toUpperCase();
    // Fallback: search label match
    const match = this.state.countryOptions.find(
      c => c.label.toLowerCase() === raw.toLowerCase()
    );
    return match ? match.value : "US";
  };

  // Extract and display profile data from client_details
  extractAndDisplayProfileData = () => {
    const { client_details } = this.state;
    let profileData;
    if (client_details && client_details.length > 0) {
      profileData = {
        comp_name: client_details[0]?.comp_name || "",
        name: client_details[0]?.name || "",
        title: client_details[0]?.title || "",
        email: client_details[0]?.email || "",
        phone: client_details[0]?.phone || "",
        address: client_details[0]?.address || "",
        address2: client_details[0]?.address2 || "",
        city: client_details[0]?.city || "",
        state: client_details[0]?.state || "",
        zip: client_details[0]?.zip || "",
        country: this.normalizeCountry(client_details[0]?.country),
      };
    } else {
      profileData = {
        comp_name: auth.getCompNameClient() || "",
        name: auth.getNameClient() || "",
        title: auth.getTitleClient() || "",
        email: auth.getEmailClient() || "",
        phone: auth.getPhoneClient() || "",
        address: auth.getClientAddress() || "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        country: this.normalizeCountry(auth.getCountryClient()),
      };
    }
    this.setState({
      profileData: profileData,
      profile_comp_name: profileData.comp_name,
      profile_name: profileData.name,
      profile_title: profileData.title,
      profile_email: profileData.email,
      profile_phone: profileData.phone,
      profile_address: profileData.address,
      profile_address2: profileData.address2,
      profile_city: profileData.city,
      profile_state: profileData.state,
      profile_zip: profileData.zip,
      profile_country: profileData.country,
    });
    return profileData;
  };

  // Handle profile form field changes
  handleProfileChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  // Toggle password visibility
  toggleProfilePassword = () => {
    this.setState({
      profilePasswordShown: !this.state.profilePasswordShown,
    });
  };

  toggleProfileConfirmPassword = () => {
    this.setState({
      profileConfirmPasswordShown: !this.state.profileConfirmPasswordShown,
    });
  };

  // Handle address selection from Google Places Autocomplete
  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";

        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });

        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }

        this.setState({
          profile_city: city && city !== "" ? city : "",
          profile_state: state && state !== "" ? state : "",
          profile_zip: zipCode && zipCode !== "" ? zipCode : "",
          profile_country: country && country !== "" ? country : "",
          profile_address:
            streetAddress && streetAddress !== "" ? streetAddress : "",
          profile_address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  // Handle address toggle between Google Places and PO Box
  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  handleSaveDraft = (formData, currentStep) => {
    let response = JSON.stringify(formData);
    let form_accountno =
      this.props.props?.match?.params?.form_accountno ||
      this.props.partnerAccountNo ||
      this.state.formAccNo;
    // Return the promise so FormRendererClient can await it
    return this.saveDraft(response, form_accountno, currentStep);
  };

  saveDraft = async (response, formAccNo, submittedStep) => {
    const { form_token, form_title, form_desc, totalSteps } = this.state;
    window.scrollTo({ top: 0, behavior: "smooth" });
    try {
      // console.log("💾 saveDraft called with:", {
      //   formAccNo,
      //   submittedStep,
      //   totalSteps,
      // });
      const submitFormReponse = await saveClientResponseDraft(
        auth.getClientAccount(),
        response,
        formAccNo,
        form_token,
        form_title,
        form_desc,
      );

      if (
        submitFormReponse.data.status === 403 ||
        submitFormReponse.data.errors === "authentication missing" ||
        submitFormReponse.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
        
        return false;
      } else if (submitFormReponse.data.status === 404) {
        this.setState({
          responseMessage:
            '<div className="alert alert-danger alert-icon mb-3"><em className="icon ni ni-cross-circle"></em> There is some error while saving the progress.</div>',
        });
        setTimeout(() => {
          this.setState({
            errorMessageSaveResponse: "",
            responseMessage: "",
          });
        }, 5000);
        return false;
      } else if (submitFormReponse.data.status === 200) {

        // Check if this is the last step AND last group in onboarding mode
        const isLastGroupOfLastStep =
          this.state.isOnboarding &&
          this.isLastStep() &&
          submittedStep === this.state.totalSteps; // submittedStep is 1-indexed, totalSteps is group count

        // console.log("📊 saveDraft group check:", {
        //   submittedStep: submittedStep,
        //   totalSteps: this.state.totalSteps,
        //   isLastGroupOfLastStep: isLastGroupOfLastStep,
        // });

        if (isLastGroupOfLastStep) {
          // console.log("🎉 Last group of last step - Calling onboarding API...");
          try {
            const onboardingResponse = await save_onboarding_for_specific_user(
              this.props.clientAccountNo,
              "client",
              this.props.stepTitle,
              this.props.formToken,
              this.props.formAccountNo,
            );
            // console.log(
            //   "✅ Onboarding API response:",
            //   onboardingResponse?.data,
            // );

            if (
              onboardingResponse?.data?.status === "success" ||
              onboardingResponse?.data?.status === 200 ||
              onboardingResponse?.data?.message === "success"
            ) {
              // console.log(
              //   "🎉 Last step completed! Showing completion message...",
              // );
              window.scrollTo({ top: 0, behavior: "smooth" });
              this.setState({
                errorMessageSaveResponse: "",
                responseMessage:
                  '<div className="alert alert-success alert-icon mb-3"><em className="icon ni ni-check-circle"></em> <strong>Success</strong><br/>Onboarding Step  successfully.</div>',
              });
              this.showToast("Onboarding step completed successfully.", "success");
              // Reload page after 2 seconds
              setTimeout(() => {
                window.location.reload();
              }, 2000);
              // console.log("✅ saveDraft returning: true (last step completed)");
              return true;
            }
          } catch (onboardingError) {
            console.error("❌ Error calling onboarding API:", onboardingError);
          }
        } else if (submittedStep < this.state.totalSteps) {
          // console.log("ℹ️ Intermediate group - Not calling onboarding API yet");
        }

        // console.log("✅ saveDraft returning: true");
        return true;
      } else {
        console.error(
          "❌ Unexpected status in saveDraft:",
          submitFormReponse.data.status,
        );
        this.setState({
          responseMessage:
            '<div className="alert alert-danger alert-icon mb-3"><em className="icon ni ni-cross-circle"></em> There is some error while saving the progress.</div>',
        });
        setTimeout(() => {
          this.setState({
            errorMessageSaveResponse: "",
            responseMessage: "",
          });
        }, 5000);
        // console.log("❌ saveDraft returning: false (unexpected status)");
        return false;
      }
    } catch (error) {
      console.error("❌ Exception in saveDraft:", error);
      this.setState({
        responseMessage:
          '<div className="alert alert-danger alert-icon mb-3"><em className="icon ni ni-cross-circle"></em> There is some error while saving the progress.</div>',
      });
      setTimeout(() => {
        this.setState({
          errorMessageSaveResponse: "",
          responseMessage: "",
        });
      }, 5000);
      // console.log("❌ saveDraft returning: false (exception)");
      return false;
    }
  };
  // Helper function to check if current step is the last step
  isLastStep = () => {
    const stepsData = this.props.stepsData;
    const currentStep = this.props.currentStep;
    return (
      stepsData && stepsData.length > 0 && currentStep === stepsData.length - 1
    );
  };

  showToast = (message, type = "error", title) => {
    this.setState({ toastMessage: "" }, () =>
      this.setState({
        toastMessage: message,
        toastType: type,
        toastTitle: title || (type === "success" ? "Success" : "Error"),
      }),
    );
  };

  handleSubmitForm = async (
    formData,
    selectedServices,
    currentGroupIndex,
    totalGroups,
  ) => {
    // console.log(
    //   "🔄 OnboardingContent.handleSubmitForm called. isOnboarding:",
    //   this.state.isOnboarding,
    //   "formData length:",
    //   formData?.length,
    //   "totalSteps:",
    //   this.state.totalSteps,
    //   "currentGroupIndex:",
    //   currentGroupIndex,
    //   "totalGroups:",
    //   totalGroups,
    // );
    // console.log("⏸️ Is last step?", this.isLastStep());
    let response = JSON.stringify(formData);

    // In onboarding mode
    if (this.state.isOnboarding) {
      try {
        // Check if form has multiple groups
        if (this.state.totalSteps > 1) {
          // Multi-group form: call saveClientResponse first
          // console.log(
          //   "📝 Multi-group form detected. Saving form data with saveClientResponse...",
          // );
          // Pass the current group index and total groups to saveResponse
          await this.saveResponse(
            response,
            this.state.formAccNo,
            totalGroups - 1,
            totalGroups,
          );

          // After saveResponse succeeds (it will call onStepComplete),
          // the onboarding API will be called in saveResponse's success handler
          return;
        } else {
          // Single-group form: save response first, then call onboarding API
          const { form_token, form_title, form_desc } = this.state;
          const singleGroupSaveResult = await saveClientResponse(
            auth.getClientAccount(),
            auth.getClientToken(),
            response,
            this.state.formAccNo,
            form_token,
            form_title,
            form_desc,
          );

          if (
            !singleGroupSaveResult ||
            singleGroupSaveResult.data?.status === 403 ||
            singleGroupSaveResult.data?.errors === "authentication missing" ||
            singleGroupSaveResult.data?.errors === "jwt expired"
          ) {
            auth.clientLogout();
            return;
          }

          if (singleGroupSaveResult.data?.status === 404) {
            this.setState({
              responseMessage:
                '<div className="alert alert-danger alert-icon mb-3"><em className="icon ni ni-cross-circle"></em> There is some error while submitting the form.</div>',
            });
            return;
          }

          // Call onboarding API
          const onboardingResponse = await save_onboarding_for_specific_user(
            this.props.clientAccountNo,
            "client",
            this.props.stepTitle,
            this.props.formToken,
            this.props.formAccountNo,
          );
          // console.log("✅ Onboarding step marked as complete");
          // console.log("📊 Response status:", onboardingResponse?.data?.status);

          // Check if this is the last step and show appropriate message
          if (this.isLastStep()) {
            // Last step of onboarding - reload page
            if (
              onboardingResponse?.data?.status === 200 ||
              onboardingResponse?.data?.status === "success" ||
              onboardingResponse?.data?.message === "success"
            ) {
              
              this.setState({
                errorMessageSaveResponse: "",
                responseMessage:
                  '<div className="alert alert-success alert-icon mb-3"><em className="icon ni ni-check-circle"></em> <strong>Success</strong><br/>Onboarding Completed successfully.</div>',
              });
              this.showToast("Onboarding completed successfully.", "success");
              // Immediately mark step as completed to show green tick
              if (
                this.props.onStepComplete &&
                typeof this.props.onStepComplete === "function"
              ) {
                this.props.onStepComplete();
              }
              // Flip the onboarding gate in place (no full reload)
              this.finishOnboarding();
              return;
            }
          } else {
            // Not the last step - just show success and navigate
            if (onboardingResponse?.data?.status === 200) {
              this.setState({
                errorMessageSaveResponse: "",
                responseMessage:
                  '<div className="alert alert-success alert-icon mb-3"><em className="icon ni ni-check-circle"></em> <strong>Success</strong><br/>Step saved successfully!</div>',
              });
              this.showToast("Step saved successfully!", "success");
              // Clear success message after 3 seconds
              setTimeout(() => {
                this.setState({
                  responseMessage: "",
                });
              }, 3000);
            }

            // Auto-navigate to next step (only for non-last steps)
            if (
              this.props.onStepComplete &&
              typeof this.props.onStepComplete === "function"
            ) {
              this.props.onStepComplete();
            }
          }
        }
      } catch (error) {
        console.error("❌ Error in onboarding form submission:", error);
        this.setState({
          errorMessageSaveResponse: "",
          responseMessage:
            '<div className="alert alert-danger alert-icon mb-3"><em className="icon ni ni-cross-circle"></em> There is some error while submitting the form.</div>',
        });
      }
    } else {
      // Non-onboarding mode: call saveResponse as usual
      this.saveResponse(
        response,
        this.state.formAccNo,
        currentGroupIndex,
        totalGroups,
      );
    }
  };

  saveResponse = async (
    response,
    formAccNo,
    currentGroupIndex,
    totalGroups,
  ) => {
    const { form_token, form_title, form_desc, totalSteps } = this.state;
    window.scrollTo({ top: 0, behavior: "smooth" });
    const submitFormReponse = await saveClientResponse(
      auth.getClientAccount(),
      auth.getClientToken(),
      response,
      formAccNo,
      form_token,
      form_title,
      form_desc,
    );
    // console.log("saveResponse response: ", submitFormReponse.data);

    if (
      submitFormReponse.data.status === 403 ||
      submitFormReponse.data.errors === "authentication missing" ||
      submitFormReponse.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (submitFormReponse.data.status === 404) {
      //window.location.replace("/error");
      this.setState({
        responseMessage:
          '<div className="alert alert-danger alert-icon mb-3"><em className="icon ni ni-cross-circle"></em> There is some error while submitting the form.</div>',
      });
    } else if (submitFormReponse.data.status === 200) {
      // console.log("✅ saveClientResponse returned status 200");

      // In onboarding mode with multi-group form: call onboarding API only when all groups are completed
      if (this.state.isOnboarding && this.state.totalSteps > 1) {
        // Determine if we're submitting the last group
        // currentGroupIndex is 0-based, so last group is at totalGroups - 1
        const isSubmittingLastGroup = currentGroupIndex >= totalGroups - 1;

        // console.log("📊 Multi-group form progress check:", {
        //   currentGroupIndex: currentGroupIndex,
        //   totalGroups: totalGroups,
        //   isSubmittingLastGroup: isSubmittingLastGroup,
        //   isLastOnboardingStep: this.isLastStep(),
        // });

        // Only call onboarding API if we just submitted the last group AND it's the last onboarding step
        if (isSubmittingLastGroup && this.isLastStep()) {
          try {
            // console.log(
            //   "📤 Last group submitted and last onboarding step! Calling onboarding API...",
            // );
            // console.log("📤 Onboarding API params:", {
            //   accountno: this.props.clientAccountNo,
            //   type: "client",
            //   title: this.props.stepTitle,
            //   token: this.props.formToken,
            //   form: this.props.formAccountNo,
            // });

            // Call onboarding API after last group is completed
            const onboardingResponse = await save_onboarding_for_specific_user(
              this.props.clientAccountNo,
              "client",
              this.props.stepTitle,
              this.props.formToken,
              this.props.formAccountNo,
            );
            // console.log(
            //   "✅ Onboarding API response:",
            //   onboardingResponse?.data,
            // );

            // Check if onboarding API returned success
            if (
              onboardingResponse?.data?.status === "success" ||
              onboardingResponse?.data?.status === 200 ||
              onboardingResponse?.data?.message === "success"
            ) {
              // console.log(
              //   "🎉 Last step completed! Showing completion message...",
              // );
              this.setState({
                errorMessageSaveResponse: "",
                responseMessage:
                  '<div className="alert alert-success alert-icon mb-3"><em className="icon ni ni-check-circle"></em> <strong>Success</strong><br/>Onboarding Step completed successfully.</div>',
              });
              this.showToast("Onboarding step completed successfully.", "success");
              // Immediately mark step as completed to show green tick
              if (
                this.props.onStepComplete &&
                typeof this.props.onStepComplete === "function"
              ) {
                this.props.onStepComplete();
              }
              // Flip the onboarding gate in place (no full reload)
              this.finishOnboarding();
              return; // Don't call onStepComplete on last step to avoid any further processing
            }
          } catch (onboardingError) {
            console.error("❌ Error calling onboarding API:", onboardingError);
          }
        } else if (!isSubmittingLastGroup) {
          // console.log(
          //   "ℹ️ Not the last group yet. Continue to next group without calling onboarding API.",
          // );
          // Show a different message for intermediate groups
          this.setState({
            errorMessageSaveResponse: "",
            responseMessage:
              '<div className="alert alert-success alert-icon mb-3"><em className="icon ni ni-check-circle"></em> Group saved successfully! Continue to the next group.</div>',
          });
          this.showToast(
            "Group saved successfully! Continue to the next group.",
            "success",
          );
          // Clear message after 3 seconds so user can continue
          setTimeout(() => {
            this.setState({
              responseMessage: "",
            });
          }, 3000);
        } else if (!this.isLastStep()) {
          // console.log(
          //   "ℹ️ Last group completed but not last onboarding step. Calling onboarding API for this step only.",
          // );
          // This is the last group of a form but not the last onboarding step
          // Still need to call onboarding API to mark this step as complete
          try {
            const onboardingResponse = await save_onboarding_for_specific_user(
              this.props.clientAccountNo,
              "client",
              this.props.stepTitle,
              this.props.formToken,
              this.props.formAccountNo,
            );
            // console.log(
            //   "✅ Step marked as complete:",
            //   onboardingResponse?.data,
            // );

            if (
              onboardingResponse?.data?.status === 200 ||
              onboardingResponse?.data?.message === "success"
            ) {
              this.setState({
                errorMessageSaveResponse: "",
                responseMessage:
                  '<div className="alert alert-success alert-icon mb-3"><em className="icon ni ni-check-circle"></em> <strong>Success</strong><br/>Step completed successfully!</div>',
              });
              this.showToast("Step completed successfully!", "success");
            }
          } catch (error) {
            console.error("❌ Error marking step complete:", error);
          }
        }
      } else {
        // Single-group form or non-onboarding mode
        this.setState({
          errorMessageSaveResponse: "",
          responseMessage:
            '<div className="alert alert-success alert-icon mb-3"><em className="icon ni ni-check-circle"></em> Your response submitted succesfully!</div>',
        });
        this.showToast("Your response was submitted successfully!", "success");
      }

      // For onboarding: Call the callback to mark step as complete
      if (
        this.props.onStepComplete &&
        typeof this.props.onStepComplete === "function"
      ) {
        if (this.state.isOnboarding) {
          // For onboarding, navigate immediately after saveClientResponse succeeds
          // But skip if it's the last step (already handled above with page reload)
          if (!this.isLastStep()) {
            this.props.onStepComplete();
          }
        } else {
          // For regular forms, wait a bit before redirecting
          setTimeout(() => {
            this.props.onStepComplete();
          }, 2000);
        }
      }
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  // Profile form update for step 0
  profileFormUpdate = async () => {
    const {
      profile_comp_name,
      profile_name,
      profile_title,
      profile_email,
      profile_phone,
      profile_address,
      profile_address2,
      profile_city,
      profile_state,
      profile_zip,
      profile_country,
      profile_password,
      profile_confirm_password,
    } = this.state;

    // Validation
    if (!profile_comp_name || profile_comp_name.trim() === "") {
      this.setState({
        profileErrorMessage: "Company name is required",
      });
      return;
    }

    if (!profile_name || profile_name.trim() === "") {
      this.setState({
        profileErrorMessage: "Full name is required",
      });
      return;
    }

    // Password validation if passwords are provided
    if (profile_password || profile_confirm_password) {
      if (profile_password !== profile_confirm_password) {
        this.setState({
          profileErrorMessage: "Passwords do not match",
        });
        return;
      }
    }

    this.setState({ profileDisabled: true, profileErrorMessage: "" });

    // Call the profile update API
    try {
      const apiResponse = await clientProfileUpdate(
        auth.getClientAccount(),
        auth.getClientToken(),
        profile_name,
        profile_title,
        profile_comp_name,
        profile_phone,
        profile_address,
        profile_city,
        profile_state,
        profile_zip,
        profile_password,
        profile_address2,
        profile_country,
      );

      if (
        apiResponse.data.status === 403 ||
        apiResponse.data.errors === "authentication missing" ||
        apiResponse.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      } else if (
        apiResponse.data.status === 200 &&
        apiResponse.data.message === "success"
      ) {
        // Update cookies with new profile data so header reflects changes
        Cookies.set(
          "client_comp_nme__",
          CryptoJS.AES.encrypt(
            apiResponse.data.data[0]["comp_name"],
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );
        Cookies.set(
          "client_name__",
          CryptoJS.AES.encrypt(
            apiResponse.data.data[0]["name"],
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );
        Cookies.set(
          "client_phone__",
          CryptoJS.AES.encrypt(
            apiResponse.data.data[0]["phone"],
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );
        Cookies.set(
          "client_title__",
          CryptoJS.AES.encrypt(
            apiResponse.data.data[0]["title"],
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );

        // Update profile data with new values
        const updatedProfileData = {
          profile_comp_name: apiResponse.data.data[0]["comp_name"],
          profile_name: apiResponse.data.data[0]["name"],
          profile_title: apiResponse.data.data[0]["title"],
          profile_email: apiResponse.data.data[0]["email"],
          profile_phone: apiResponse.data.data[0]["phone"],
          profile_address: apiResponse.data.data[0]["address"],
          profile_address2: apiResponse.data.data[0]["address2"],
          profile_city: apiResponse.data.data[0]["city"],
          profile_state: apiResponse.data.data[0]["state"],
          profile_zip: apiResponse.data.data[0]["zip"],
          profile_country: apiResponse.data.data[0]["country"],
        };

        this.setState({
          profileSuccessMessage: "Profile updated successfully!",
          profileDisabled: false,
          profileErrorMessage: "",
          ...updatedProfileData,
        });

        // Update Redux store with new profile data so other parts of app get updated
        const updatedSettings = {
          ...this.props.defaultSettings,
          comp_name: apiResponse.data.data[0]["comp_name"],
          name: apiResponse.data.data[0]["name"],
          title: apiResponse.data.data[0]["title"],
          email: apiResponse.data.data[0]["email"],
          phone: apiResponse.data.data[0]["phone"],
          address: apiResponse.data.data[0]["address"],
          address2: apiResponse.data.data[0]["address2"],
          city: apiResponse.data.data[0]["city"],
          state: apiResponse.data.data[0]["state"],
          zip: apiResponse.data.data[0]["zip"],
          country: apiResponse.data.data[0]["country"],
        };
        this.props.addSettings(updatedSettings);

        setTimeout(() => {
          this.setState({
            profileSuccessMessage: "",
          });
          // Refresh page after 3 seconds to ensure all updates are reflected
          window.location.reload();
        }, 3000);
      } else {
        this.setState({
          profileErrorMessage: "Error updating profile. Please try again.",
          profileDisabled: false,
        });
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      this.setState({
        profileErrorMessage: "Error updating profile. Please try again.",
        profileDisabled: false,
      });
    }
  };

  render() {
    const { step } = this.state;
    const { email, VerifyUsernameButton } = this.state;
    const values = {
      email,
      VerifyUsernameButton,
    };
    //$(".nk-block .MUIDataTable-paper-2").css("padding", "10px");
    return (
      <div
        className="nk-content "
        id="Support_Block"
        style={{ padding: "0" }}
      >
        <NotificationToast
          message={this.state.toastMessage}
          type={this.state.toastType}
          title={this.state.toastTitle}
          onDismiss={() => this.setState({ toastMessage: "" })}
        />
        <div className="container-fluid px-0">
          {this.props.defaultSettings === "missing" &&
          this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" &&
          this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner" style={{ overflow: "clip" }}>
            <div className="nk-content-body" style={{ paddingLeft: 0, paddingRight: 0 }}>
              {/* PAGE TITLE START */}
              <div className="nk-block-head-content agr-page-container onboarding-head-block" style={{ padding: "16px 15px 0" }}>
                {!this.props.stepsData || this.props.stepsData.length === 0 ? (
                  /* Steps not loaded yet — message card skeleton keeps the
                     layout stable as part of the single page skeleton */
                  <div style={{ background: "#fff", border: "1px solid #e5e9f2", borderRadius: "12px", padding: "20px 24px", marginBottom: "10px" }}>
                    <div className="obs-skel" style={{ width: "34%", height: "22px", marginBottom: "12px" }} />
                    <div className="obs-skel" style={{ width: "72%", height: "12px" }} />
                  </div>
                ) : (
                  (this.props.onboardingTitle || this.props.onboardingMessage) && (
                    <div className="onboarding-message-card d-none d-md-block" style={{ background: "#fff", border: "1px solid #e5e9f2", borderRadius: "12px", padding: "20px 24px", marginBottom: "10px" }}>
                      {this.props.onboardingTitle && (
                        <h3 className="nk-block-title page-title" style={{ marginBottom: this.props.onboardingMessage ? "6px" : 0 }}>
                          {this.props.onboardingTitle}
                        </h3>
                      )}
                      {this.props.onboardingMessage && (
                        <p className="text-dark mb-0">
                          {this.props.onboardingMessage}
                        </p>
                      )}
                    </div>
                  )
                )}
              </div>
              {/* RIGHTS MODAL START */}

              {/* RIGHTS MODAL End */}
              <div className="nk-block-between d-none d-md-block">
                <div className="nk-block-head-content" id="HeadContent">
                  <div className="toggle-wrap nk-block-tools-toggle">
                    <a
                      href="#"
                      className="btn btn-icon btn-trigger toggle-expand mr-n1"
                      data-target="pageMenu"
                    >
                      <em className="icon ni ni-more-v"></em>
                    </a>
                  </div>
                </div>
              </div>

              {/* PAGE TITLE END */}
              <div className="nk-block form_main_container" style={{ marginBottom: 0 }}>
                <div className="row mx-0" style={{ marginTop: 0 }}>
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12 px-0">
                    <div className="nk-block nk-block-lg">
                      {/* card card-bordered removed — dashboard-only flat style */}
                      <div>
                        {/* key remounts the step content on every step change so the
                            fade-in animation replays (smooth agreement/form swap) */}
                        <div key={this.props.currentStep} className="card-inner agr-page-container onboarding-step-fade" style={{ padding: "0" }}>
                          {/* Inline success banners removed — success is shown via the toast
                              (and the completion card for the final step) instead. */}
                          {this.state.errorMessage !== "" ? (
                            <div
                              className="example-alert example-alert-revoke mt-3 mb-3"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.onboardingCompleting ? (
                            this.renderOnboardingComplete()
                          ) : this.state.tableLoader ? (
                            this.renderStepSkeleton()
                          ) : (
                            <>
                              {this.state.link_form === 1 ? (
                                <div className="nk-block mt-4">
                                  <div className="nk-block-content nk-error-ld">
                                    <h3 className="nk-error-title text-center">
                                      Link Only
                                    </h3>
                                    <div className="alert alert-light text-dark">
                                      This form contains an external link.{" "}
                                      <a
                                        href={this.state.external_link}
                                        target="_blank"
                                      >
                                        Click Here
                                      </a>{" "}
                                      to be redirected to the specified
                                      destination.
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  {(this.state.isFilled !== 1 && this.props.agreementData?.type !== "basic") ||
                                  this.state.isSkipped === 1 ? (
                                    this.state.formData ? (
                                      <div>
                                        <FormRendererClient
                                          formData={JSON.parse(
                                            this.state.formData,
                                          )}
                                          formTitle={this.state.form_title}
                                          formDescription={this.state.form_desc}
                                          onSubmit={this.handleSubmitForm}
                                          onToast={this.showToast}
                                          groups={this.state.groups}
                                          responseMessage={""}
                                          clientData={this.state.client_details}
                                          chatgpt_intergation={
                                            this.state.chatgpt_intergation
                                          }
                                          chatgpt_api_key={
                                            this.state.chatgpt_api_key
                                          }
                                          allow_submit={this.state.allow_submit}
                                          draftData={this.state.draftData}
                                          saveDraft={this.handleSaveDraft}
                                          progressStep={this.state.progressStep}
                                          viewFrom="client-logged-in"
                                          hideBg={true}
                                          allow_agent_name={
                                            this.state.allow_agent_name
                                          }
                                          isCurrentStepFilled={
                                            this.state.isCurrentStepFilled
                                          }
                                          isOnboarding={true}
                                          isFormInReviewMode={
                                            this.state.isFilled === 1
                                          }
                                          clientAccountNo={
                                            this.props.clientAccountNo
                                          }
                                          formAccountNo={
                                            this.props.formAccountNo
                                          }
                                          formToken={this.props.formToken}
                                          stepTitle={this.props.stepTitle}
                                          allowSkip={this.props.allowSkip}
                                          onSkipStep={this.handleSkipStep}
                                          stepsData={this.props.stepsData}
                                          isFilled={this.state.isFilled}
                                          isSkipped={this.state.isSkipped}
                                          onNextStep={this.handleNextStep}
                                          captcha_enabled={this.state.captcha_enabled}
                                          link_form={this.state.link_form}
                                          //id={this.state.forms[0].id}
                                          //setShowResponse={(value) => this.setState({ showResponse: value })}
                                        />
                                      </div>
                                    ) : this.props.agreementData?.type === "agreement" ? (
                                      // Agreement step (unfilled): render the Agreement signing component.
                                      // Agreement always mounts so its componentDidMount API call can run.
                                      // The loader overlay covers it until onAgreementReady fires.
                                      <div className="onboarding-agr-wrap">
                                        <style>{`
                                          .onboarding-agr-wrap { overflow: clip; max-width: 100%; width: 100%; }
                                          /* Step container already provides the page inset — don't double it */
                                          .onboarding-agr-wrap .agr-page-container { padding-left: 0 !important; padding-right: 0 !important; }
                                          .onboarding-agr-wrap .agr-stepper-row { flex-wrap: wrap !important; }
                                          .onboarding-agr-wrap .agr-download-btn { margin-left: auto; }
                                        `}</style>
                                        {!this.state.contentReady && this.renderStepSkeleton()}
                                        <div style={{ display: this.state.contentReady ? "block" : "none" }}>
                                          <Agreement
                                            agreementAccountNo={this.props.agreementData?.agreement_accountno || ""}
                                            agreementSigned={this.handleAgreementSigned}
                                            scrollHeightOffset={330}
                                            hideDocumentNav={true}
                                            ref={(el) => { this.agreementRef = el; }}
                                            onAgreementReady={() => this.setState({ contentReady: true })}
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      this.renderStepSkeleton()
                                    )
                                  ) : (this.state.isFilled === 1 || this.props.agreementData?.type === "basic") &&
                                    this.state.isSkipped !== 1 ? (
                                    <>
                                      {this.props.agreementData?.type !== "agreement" &&
                                        this.props.agreementData?.type !== "basic" && (
                                          <div className="nk-block mt-4">
                                            <div className="nk-block-content nk-error-ld">
                                              <h3 className="nk-error-title text-center">
                                                Form Submitted
                                              </h3>
                                              <div className="alert alert-light text-dark">
                                                Thank you for submitting your
                                                form. We have successfully
                                                received your information and
                                                are processing it. Our team will
                                                review the details and get back
                                                to you shortly if further
                                                information is needed. We
                                                appreciate your time and effort
                                                in providing us with the
                                                necessary details.
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      {this.state.allow_multiple === 1 || this.props.agreementData?.type === "basic" ? (
                                        this.props.agreementData?.type === "agreement" ? (
                                          <div className="nk-block mt-4">
                                            <div className="nk-block-content nk-error-ld">
                                              <div
                                                style={{
                                                  textAlign: "center",
                                                  paddingTop: "30px",
                                                  paddingBottom: "30px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    marginBottom: "20px",
                                                  }}
                                                >
                                                  <em
                                                    className="icon ni ni-check-circle"
                                                    style={{
                                                      fontSize: "60px",
                                                      color: "#27ae60",
                                                    }}
                                                  ></em>
                                                </div>
                                                <h3
                                                  style={{
                                                    color: "#27ae60",
                                                    marginBottom: "15px",
                                                    fontSize: "28px",
                                                    fontWeight: "600",
                                                  }}
                                                >
                                                  Agreement Signed
                                                </h3>
                                                <p
                                                  style={{
                                                    color: "#555",
                                                    fontSize: "16px",
                                                    marginBottom: "20px",
                                                    lineHeight: "1.6",
                                                  }}
                                                >
                                                  You have successfully signed
                                                  this agreement. Your signature
                                                  has been recorded and the
                                                  document is now complete.
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        ) : this.props.agreementData?.type === "basic" ? (
                                          // For Basic Information step when filled, show editable profile modal
                                          this.state.profileData ? (
                                            <div className="nk-block">
                                              {this.state
                                                .profileErrorMessage && (
                                                <div className="example-alert">
                                                  <div className="alert alert-pro alert-danger">
                                                    <div className="alert-text">
                                                      <h4>Error</h4>
                                                      <p>
                                                        {
                                                          this.state
                                                            .profileErrorMessage
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                              {this.state
                                                .profileSuccessMessage && (
                                                <div className="example-alert">
                                                  <div className="alert alert-pro alert-success">
                                                    <div className="alert-text">
                                                      <h4>Success</h4>
                                                      <p>
                                                        {
                                                          this.state
                                                            .profileSuccessMessage
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                              <div className="card card-bordered">
                                                <div className="card-inner">
                                                  <div className="row g-4">
                                                    {/* Company Name Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="Company Name *"
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        value={this.state.profile_comp_name}
                                                        onChange={this.handleProfileChange("profile_comp_name")}
                                                        placeholder="Company Name"
                                                        helperText="Allowed: _ . - , : & ( ) | ! @"
                                                      />
                                                    </div>

                                                    {/* Full Name Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="Full Name *"
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        value={this.state.profile_name}
                                                        onChange={this.handleProfileChange("profile_name")}
                                                        placeholder="Full Name"
                                                        helperText="Allowed: ' - . , : ( ) | ! @"
                                                      />
                                                    </div>

                                                    {/* Title Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="Title"
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        value={this.state.profile_title}
                                                        onChange={this.handleProfileChange("profile_title")}
                                                        placeholder="Title"
                                                        helperText="Allowed: _ - . & , : ( ) | ! @"
                                                      />
                                                    </div>

                                                    {/* Email Field */}
                                                    <div className="col-lg-6">
                                                      <MutextField
                                                        label="Email *"
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        type="email"
                                                        value={this.state.profile_email}
                                                        onChange={this.handleProfileChange("profile_email")}
                                                        placeholder="Enter email"
                                                      />
                                                    </div>

                                                    {/* Phone Field */}
                                                    <div className="col-lg-6">
                                                      <div className="form-group">
                                                        <PhoneInput2
                                                          country="us"
                                                          value={this.state.profile_phone}
                                                          onChange={(phone) => this.setState({ profile_phone: phone })}
                                                          inputStyle={{ width: "100%", height: "56px", borderColor: "#c4cdd5", borderRadius: "4px" }}
                                                          buttonStyle={{ borderColor: "#c4cdd5", borderRadius: "4px 0 0 4px" }}
                                                          placeholder="Enter phone number"
                                                          enableSearch
                                                        />
                                                      </div>
                                                    </div>

                                                    {/* Address Field with Google Places Autocomplete */}
                                                    <div className="col-lg-6">
                                                      <div className="form-group">
                                                        {this.state.useGooglePlaces ? (
                                                          <div style={{ position: "relative" }}>
                                                            <label style={{ position: "absolute", top: "-9px", left: "10px", background: "#fff", padding: "0 4px", fontSize: "12px", color: "rgba(0,0,0,0.54)", zIndex: 1, pointerEvents: "none", lineHeight: 1 }}>
                                                              Address
                                                            </label>
                                                            {this.state.address_autocomplete === "Yes" && (
                                                              <a onClick={this.handleToggle} style={{ position: "absolute", top: "-9px", right: "10px", background: "#fff", padding: "0 4px", cursor: "pointer", fontSize: "11px", color: "#0066cc", textDecoration: "underline", zIndex: 1, lineHeight: 1 }}>
                                                                {this.state.toggleButtonText}
                                                              </a>
                                                            )}
                                                            <GooglePlacesAutocomplete
                                                              apiKey={process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}
                                                              selectProps={{
                                                                value: this.state.profile_address
                                                                  ? { label: this.state.profile_address, value: this.state.profile_address }
                                                                  : null,
                                                                onChange: this.handleAddressSelect,
                                                                placeholder: "Enter your address..",
                                                                styles: {
                                                                  control: (provided, state) => ({
                                                                    ...provided,
                                                                    minHeight: "56px",
                                                                    borderColor: state.isFocused ? "#3f51b5" : "rgba(0,0,0,0.23)",
                                                                    borderRadius: "4px",
                                                                    boxShadow: state.isFocused ? "0 0 0 1px #3f51b5" : "none",
                                                                    "&:hover": { borderColor: "rgba(0,0,0,0.87)" },
                                                                  }),
                                                                  valueContainer: (provided) => ({ ...provided, padding: "2px 14px" }),
                                                                  input: (provided) => ({ ...provided, color: "rgba(0,0,0,0.87)", fontSize: "14px", margin: 0, padding: 0 }),
                                                                  singleValue: (provided) => ({ ...provided, color: "rgba(0,0,0,0.87)", fontSize: "14px" }),
                                                                  placeholder: (provided) => ({ ...provided, color: "rgba(0,0,0,0.42)", fontSize: "14px" }),
                                                                  option: (provided, state) => ({ ...provided, color: "rgba(0,0,0,0.87)", backgroundColor: state.isFocused ? "rgba(0,0,0,0.08)" : "#fff", fontSize: "14px" }),
                                                                  menu: (provided) => ({ ...provided, zIndex: 9, borderRadius: "4px", boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }),
                                                                  dropdownIndicator: () => ({ display: "none" }),
                                                                  indicatorSeparator: () => ({ display: "none" }),
                                                                },
                                                              }}
                                                            />
                                                          </div>
                                                        ) : (
                                                          <div style={{ position: "relative" }}>
                                                            {this.state.address_autocomplete === "Yes" && (
                                                              <a onClick={this.handleToggle} style={{ position: "absolute", top: "-9px", right: "10px", background: "#fff", padding: "0 4px", cursor: "pointer", fontSize: "11px", color: "#0066cc", textDecoration: "underline", zIndex: 1, lineHeight: 1 }}>
                                                                {this.state.toggleButtonText}
                                                              </a>
                                                            )}
                                                            <MutextField
                                                              label="Address"
                                                              variant="outlined"
                                                              fullWidth
                                                              value={this.state.profile_address}
                                                              onChange={this.handleProfileChange("profile_address")}
                                                              placeholder="Enter Po Box address"
                                                            />
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>

                                                    {/* Apartment, Suite, Etc. Field */}
                                                    <div className="col-lg-6">
                                                      <MutextField
                                                        label="Apartment, Suite, Etc."
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        value={this.state.profile_address2}
                                                        onChange={this.handleProfileChange("profile_address2")}
                                                        placeholder="Apartment, Suite, Etc."
                                                      />
                                                    </div>

                                                    {/* City Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="City"
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        value={this.state.profile_city}
                                                        onChange={this.handleProfileChange("profile_city")}
                                                        placeholder="Enter your city"
                                                      />
                                                    </div>

                                                    {/* State Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="State"
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        value={this.state.profile_state}
                                                        onChange={this.handleProfileChange("profile_state")}
                                                        placeholder="State"
                                                      />
                                                    </div>

                                                    {/* Zip Code Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="Zip Code"
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        value={this.state.profile_zip}
                                                        onChange={this.handleProfileChange("profile_zip")}
                                                        placeholder="Zip code"
                                                      />
                                                    </div>

                                                    {/* Country Dropdown Field */}
                                                    <div className="col-lg-12">
                                                      <Autocomplete
                                                        options={this.state.countryOptions}
                                                        getOptionLabel={(option) => option.label || ""}
                                                        value={this.state.countryOptions.find((c) => c.value === this.state.profile_country) || null}
                                                        onChange={(e, option) => {
                                                          this.setState({ profile_country: option ? option.value : "" });
                                                        }}
                                                        renderInput={(params) => (
                                                          <MutextField
                                                            {...params}
                                                            label="Country"
                                                            variant="outlined"
                                                            
                                                            placeholder="Select Country"
                                                          />
                                                        )}
                                                      />
                                                    </div>

                                                    {/* Password Field with Strength Bar */}
                                                    {/* Password Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="Password"
                                                        variant="outlined"
                                                        fullWidth
                                                        type={this.state.profilePasswordShown ? "text" : "password"}
                                                        value={this.state.profile_password}
                                                        onChange={this.handleProfileChange("profile_password")}
                                                        placeholder="Enter your password"
                                                        InputProps={{
                                                          endAdornment: (
                                                            <InputAdornment position="end">
                                                              <IconButton
                                                                size="small"
                                                                tabIndex={-1}
                                                                onClick={this.toggleProfilePassword}
                                                              >
                                                                <em className={`icon ni ${this.state.profilePasswordShown ? "ni-eye-off" : "ni-eye"}`}></em>
                                                              </IconButton>
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                      />
                                                      {this.state.profile_password && (
                                                        <PasswordStrengthBar
                                                          password={this.state.profile_password}
                                                          scoreWords={["weak", "fair", "good", "strong", "stronger"]}
                                                          shortScoreWord="weak"
                                                          score={Math.floor((this.state.profile_password.length / 20) * 4)}
                                                          barColors={["#d8313a", "#f19f4c", "#f8d52f", "#95d62a", "#3fa62a"]}
                                                        />
                                                      )}
                                                    </div>

                                                    {/* Confirm Password Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="Confirm Password"
                                                        variant="outlined"
                                                        fullWidth
                                                        type={this.state.profileConfirmPasswordShown ? "text" : "password"}
                                                        value={this.state.profile_confirm_password}
                                                        onChange={this.handleProfileChange("profile_confirm_password")}
                                                        placeholder="Enter confirm password"
                                                        InputProps={{
                                                          endAdornment: (
                                                            <InputAdornment position="end">
                                                              <IconButton
                                                                size="small"
                                                                tabIndex={-1}
                                                                onClick={this.toggleProfileConfirmPassword}
                                                              >
                                                                <em className={`icon ni ${this.state.profileConfirmPasswordShown ? "ni-eye-off" : "ni-eye"}`}></em>
                                                              </IconButton>
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                      />
                                                    </div>

                                                    {/* Update Profile Button */}
                                                    <div className="col-lg-12 text-right">
                                                      <button
                                                        type="button"
                                                        className="btn btn-lg"
                                                        onClick={() =>
                                                          this.profileFormUpdate()
                                                        }
                                                        style={{
                                                          backgroundColor:
                                                            "#1f3757",
                                                          color: "#fff",
                                                          float: "right",
                                                        }}
                                                        disabled={
                                                          this.state
                                                            .profileDisabled
                                                        }
                                                      >
                                                        Update Profile
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            TableLoader()
                                          )
                                        ) : this.state.formData ? (
                                          <div>
                                            <FormRendererClient
                                              formData={JSON.parse(
                                                this.state.formData,
                                              )}
                                              formTitle={this.state.form_title}
                                              formDescription={
                                                this.state.form_desc
                                              }
                                              onSubmit={this.handleSubmitForm}
                                              onToast={this.showToast}
                                              groups={this.state.groups}
                                              responseMessage={""}
                                              clientData={
                                                this.state.client_details
                                              }
                                              chatgpt_intergation={
                                                this.state.chatgpt_intergation
                                              }
                                              chatgpt_api_key={
                                                this.state.chatgpt_api_key
                                              }
                                              allow_submit={
                                                this.state.allow_submit
                                              }
                                              draftData={this.state.draftData}
                                              saveDraft={this.handleSaveDraft}
                                              progressStep={
                                                this.state.progressStep
                                              }
                                              viewFrom="client-logged-in"
                                              hideBg={true}
                                              allow_agent_name={
                                                this.state.allow_agent_name
                                              }
                                              isCurrentStepFilled={
                                                this.state.isCurrentStepFilled
                                              }
                                              isOnboarding={true}
                                              isFormInReviewMode={
                                                this.state.isFilled === 1
                                              }
                                              clientAccountNo={
                                                this.props.clientAccountNo
                                              }
                                              formAccountNo={
                                                this.props.formAccountNo
                                              }
                                              stepTitle={this.props.stepTitle}
                                              isFilled={this.state.isFilled}
                                              isSkipped={this.state.isSkipped}
                                              onNextStep={this.handleNextStep}
                                              captcha_enabled={this.state.captcha_enabled}
                                              link_form={this.state.link_form}
                                              //id={this.state.forms[0].id}
                                              //setShowResponse={(value) => this.setState({ showResponse: value })}
                                            />
                                          </div>
                                        ) : (
                                          TableLoader()
                                        )
                                      ) : this.state.allow_multiple === 0 ? (
                                        this.props.agreementData?.type === "agreement" ? (
                                          <div className="nk-block mt-4">
                                            <div className="nk-block-content nk-error-ld">
                                              <div
                                                style={{
                                                  textAlign: "center",
                                                  paddingTop: "30px",
                                                  paddingBottom: "30px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    marginBottom: "20px",
                                                  }}
                                                >
                                                  <em
                                                    className="icon ni ni-check-circle"
                                                    style={{
                                                      fontSize: "60px",
                                                      color: "#27ae60",
                                                    }}
                                                  ></em>
                                                </div>
                                                <h3
                                                  style={{
                                                    color: "#27ae60",
                                                    marginBottom: "15px",
                                                    fontSize: "28px",
                                                    fontWeight: "600",
                                                  }}
                                                >
                                                  Agreement Signed
                                                </h3>
                                                <p
                                                  style={{
                                                    color: "#555",
                                                    fontSize: "16px",
                                                    marginBottom: "20px",
                                                    lineHeight: "1.6",
                                                  }}
                                                >
                                                  You have successfully signed
                                                  this agreement. Your signature
                                                  has been recorded and the
                                                  document is now complete.
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        ) : this.props.agreementData?.type === "basic" ? (
                                          // For Basic Information step when filled, show editable profile modal
                                          this.state.profileData ? (
                                            <div className="nk-block">
                                              {this.state
                                                .profileErrorMessage && (
                                                <div className="example-alert">
                                                  <div className="alert alert-pro alert-danger">
                                                    <div className="alert-text">
                                                      <h4>Error</h4>
                                                      <p>
                                                        {
                                                          this.state
                                                            .profileErrorMessage
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                              {this.state
                                                .profileSuccessMessage && (
                                                <div className="example-alert">
                                                  <div className="alert alert-pro alert-success">
                                                    <div className="alert-text">
                                                      <h4>Success</h4>
                                                      <p>
                                                        {
                                                          this.state
                                                            .profileSuccessMessage
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                              <div className="card card-bordered">
                                                <div className="card-inner">
                                                  <div className="row g-4">
                                                    {/* Company Name Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="Company Name *"
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        value={this.state.profile_comp_name}
                                                        onChange={this.handleProfileChange("profile_comp_name")}
                                                        placeholder="Company Name"
                                                        helperText="Allowed: _ . - , : & ( ) | ! @"
                                                      />
                                                    </div>

                                                    {/* Full Name Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="Full Name *"
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        value={this.state.profile_name}
                                                        onChange={this.handleProfileChange("profile_name")}
                                                        placeholder="Full Name"
                                                        helperText="Allowed: ' - . , : ( ) | ! @"
                                                      />
                                                    </div>

                                                    {/* Title Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="Title"
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        value={this.state.profile_title}
                                                        onChange={this.handleProfileChange("profile_title")}
                                                        placeholder="Title"
                                                        helperText="Allowed: _ - . & , : ( ) | ! @"
                                                      />
                                                    </div>

                                                    {/* Email Field */}
                                                    <div className="col-lg-6">
                                                      <MutextField
                                                        label="Email *"
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        type="email"
                                                        value={this.state.profile_email}
                                                        onChange={this.handleProfileChange("profile_email")}
                                                        placeholder="Enter email"
                                                      />
                                                    </div>

                                                    {/* Phone Field */}
                                                    <div className="col-lg-6">
                                                      <div className="form-group">
                                                        <PhoneInput2
                                                          country="us"
                                                          value={this.state.profile_phone}
                                                          onChange={(phone) => this.setState({ profile_phone: phone })}
                                                          inputStyle={{ width: "100%", height: "56px", borderColor: "#c4cdd5", borderRadius: "4px" }}
                                                          buttonStyle={{ borderColor: "#c4cdd5", borderRadius: "4px 0 0 4px" }}
                                                          placeholder="Enter phone number"
                                                          enableSearch
                                                        />
                                                      </div>
                                                    </div>

                                                    {/* Address Field with Google Places Autocomplete */}
                                                    <div className="col-lg-6">
                                                      <div className="form-group">
                                                        {this.state.useGooglePlaces ? (
                                                          <div style={{ position: "relative" }}>
                                                            <label style={{ position: "absolute", top: "-9px", left: "10px", background: "#fff", padding: "0 4px", fontSize: "12px", color: "rgba(0,0,0,0.54)", zIndex: 1, pointerEvents: "none", lineHeight: 1 }}>
                                                              Address
                                                            </label>
                                                            {this.state.address_autocomplete === "Yes" && (
                                                              <a onClick={this.handleToggle} style={{ position: "absolute", top: "-9px", right: "10px", background: "#fff", padding: "0 4px", cursor: "pointer", fontSize: "11px", color: "#0066cc", textDecoration: "underline", zIndex: 1, lineHeight: 1 }}>
                                                                {this.state.toggleButtonText}
                                                              </a>
                                                            )}
                                                            <GooglePlacesAutocomplete
                                                              apiKey={process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}
                                                              selectProps={{
                                                                value: this.state.profile_address
                                                                  ? { label: this.state.profile_address, value: this.state.profile_address }
                                                                  : null,
                                                                onChange: this.handleAddressSelect,
                                                                placeholder: "Enter your address..",
                                                                styles: {
                                                                  control: (provided, state) => ({
                                                                    ...provided,
                                                                    minHeight: "56px",
                                                                    borderColor: state.isFocused ? "#3f51b5" : "rgba(0,0,0,0.23)",
                                                                    borderRadius: "4px",
                                                                    boxShadow: state.isFocused ? "0 0 0 1px #3f51b5" : "none",
                                                                    "&:hover": { borderColor: "rgba(0,0,0,0.87)" },
                                                                  }),
                                                                  valueContainer: (provided) => ({ ...provided, padding: "2px 14px" }),
                                                                  input: (provided) => ({ ...provided, color: "rgba(0,0,0,0.87)", fontSize: "14px", margin: 0, padding: 0 }),
                                                                  singleValue: (provided) => ({ ...provided, color: "rgba(0,0,0,0.87)", fontSize: "14px" }),
                                                                  placeholder: (provided) => ({ ...provided, color: "rgba(0,0,0,0.42)", fontSize: "14px" }),
                                                                  option: (provided, state) => ({ ...provided, color: "rgba(0,0,0,0.87)", backgroundColor: state.isFocused ? "rgba(0,0,0,0.08)" : "#fff", fontSize: "14px" }),
                                                                  menu: (provided) => ({ ...provided, zIndex: 9, borderRadius: "4px", boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }),
                                                                  dropdownIndicator: () => ({ display: "none" }),
                                                                  indicatorSeparator: () => ({ display: "none" }),
                                                                },
                                                              }}
                                                            />
                                                          </div>
                                                        ) : (
                                                          <div style={{ position: "relative" }}>
                                                            {this.state.address_autocomplete === "Yes" && (
                                                              <a onClick={this.handleToggle} style={{ position: "absolute", top: "-9px", right: "10px", background: "#fff", padding: "0 4px", cursor: "pointer", fontSize: "11px", color: "#0066cc", textDecoration: "underline", zIndex: 1, lineHeight: 1 }}>
                                                                {this.state.toggleButtonText}
                                                              </a>
                                                            )}
                                                            <MutextField
                                                              label="Address"
                                                              variant="outlined"
                                                              fullWidth
                                                              value={this.state.profile_address}
                                                              onChange={this.handleProfileChange("profile_address")}
                                                              placeholder="Enter Po Box address"
                                                            />
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>

                                                    {/* Apartment, Suite, Etc. Field */}
                                                    <div className="col-lg-6">
                                                      <MutextField
                                                        label="Apartment, Suite, Etc."
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        value={this.state.profile_address2}
                                                        onChange={this.handleProfileChange("profile_address2")}
                                                        placeholder="Apartment, Suite, Etc."
                                                      />
                                                    </div>

                                                    {/* City Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="City"
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        value={this.state.profile_city}
                                                        onChange={this.handleProfileChange("profile_city")}
                                                        placeholder="Enter your city"
                                                      />
                                                    </div>

                                                    {/* State Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="State"
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        value={this.state.profile_state}
                                                        onChange={this.handleProfileChange("profile_state")}
                                                        placeholder="State"
                                                      />
                                                    </div>

                                                    {/* Zip Code Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="Zip Code"
                                                        variant="outlined"
                                                        fullWidth
                                                        
                                                        value={this.state.profile_zip}
                                                        onChange={this.handleProfileChange("profile_zip")}
                                                        placeholder="Zip code"
                                                      />
                                                    </div>

                                                    {/* Country Dropdown Field */}
                                                    <div className="col-lg-12">
                                                      <Autocomplete
                                                        options={this.state.countryOptions}
                                                        getOptionLabel={(option) => option.label || ""}
                                                        value={this.state.countryOptions.find((c) => c.value === this.state.profile_country) || null}
                                                        onChange={(e, option) => {
                                                          this.setState({ profile_country: option ? option.value : "" });
                                                        }}
                                                        renderInput={(params) => (
                                                          <MutextField
                                                            {...params}
                                                            label="Country"
                                                            variant="outlined"
                                                            
                                                            placeholder="Select Country"
                                                          />
                                                        )}
                                                      />
                                                    </div>

                                                    {/* Password Field with Strength Bar */}
                                                    {/* Password Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="Password"
                                                        variant="outlined"
                                                        fullWidth
                                                        type={this.state.profilePasswordShown ? "text" : "password"}
                                                        value={this.state.profile_password}
                                                        onChange={this.handleProfileChange("profile_password")}
                                                        placeholder="Enter your password"
                                                        InputProps={{
                                                          endAdornment: (
                                                            <InputAdornment position="end">
                                                              <IconButton
                                                                tabIndex={-1}
                                                                onClick={this.toggleProfilePassword}
                                                              >
                                                                <em className={`icon ni ${this.state.profilePasswordShown ? "ni-eye-off" : "ni-eye"}`}></em>
                                                              </IconButton>
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                      />
                                                      {this.state.profile_password && (
                                                        <PasswordStrengthBar
                                                          password={this.state.profile_password}
                                                          scoreWords={["weak", "fair", "good", "strong", "stronger"]}
                                                          shortScoreWord="weak"
                                                          score={Math.floor((this.state.profile_password.length / 20) * 4)}
                                                          barColors={["#d8313a", "#f19f4c", "#f8d52f", "#95d62a", "#3fa62a"]}
                                                        />
                                                      )}
                                                    </div>

                                                    {/* Confirm Password Field */}
                                                    <div className="col-lg-4">
                                                      <MutextField
                                                        label="Confirm Password"
                                                        variant="outlined"
                                                        fullWidth
                                                        type={this.state.profileConfirmPasswordShown ? "text" : "password"}
                                                        value={this.state.profile_confirm_password}
                                                        onChange={this.handleProfileChange("profile_confirm_password")}
                                                        placeholder="Enter confirm password"
                                                        InputProps={{
                                                          endAdornment: (
                                                            <InputAdornment position="end">
                                                              <IconButton
                                                                tabIndex={-1}
                                                                onClick={this.toggleProfileConfirmPassword}
                                                              >
                                                                <em className={`icon ni ${this.state.profileConfirmPasswordShown ? "ni-eye-off" : "ni-eye"}`}></em>
                                                              </IconButton>
                                                            </InputAdornment>
                                                          ),
                                                        }}
                                                      />
                                                    </div>

                                                    {/* Update Profile Button */}
                                                    <div className="col-lg-12 text-right">
                                                      <button
                                                        type="button"
                                                        className="btn btn-lg"
                                                        onClick={() =>
                                                          this.profileFormUpdate()
                                                        }
                                                        style={{
                                                          backgroundColor:
                                                            "#1f3757",
                                                          color: "#fff",
                                                          float: "right",
                                                        }}
                                                        disabled={
                                                          this.state
                                                            .profileDisabled
                                                        }
                                                      >
                                                        Update Profile
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            TableLoader()
                                          )
                                        ) : (
                                          <>
                                            {this.state.formData ? (
                                              <div>
                                                <FormRendererClient
                                                  formData={JSON.parse(
                                                    this.state.formData,
                                                  )}
                                                  formTitle={
                                                    this.state.form_title
                                                  }
                                                  formDescription={
                                                    this.state.form_desc
                                                  }
                                                  onSubmit={
                                                    this.handleSubmitForm
                                                  }
                                                  onToast={this.showToast}
                                                  groups={this.state.groups}
                                                  responseMessage={""}
                                                  clientData={
                                                    this.state.client_details
                                                  }
                                                  chatgpt_intergation={
                                                    this.state
                                                      .chatgpt_intergation
                                                  }
                                                  chatgpt_api_key={
                                                    this.state.chatgpt_api_key
                                                  }
                                                  allow_submit={
                                                    this.state.allow_submit
                                                  }
                                                  draftData={
                                                    this.state.isFilled === 1
                                                      ? this.state.submittedData
                                                      : this.state.draftData
                                                  }
                                                  saveDraft={
                                                    this.handleSaveDraft
                                                  }
                                                  progressStep={
                                                    this.state.progressStep
                                                  }
                                                  viewFrom="client-logged-in"
                                                  hideBg={true}
                                                  allow_agent_name={
                                                    this.state.allow_agent_name
                                                  }
                                                  isCurrentStepFilled={
                                                    this.state
                                                      .isCurrentStepFilled
                                                  }
                                                  isOnboarding={true}
                                                  isFormInReviewMode={
                                                    this.state.isFilled === 1
                                                  }
                                                  clientAccountNo={
                                                    this.props.clientAccountNo
                                                  }
                                                  formAccountNo={
                                                    this.props.formAccountNo
                                                  }
                                                  formToken={
                                                    this.props.formToken
                                                  }
                                                  stepTitle={
                                                    this.props.stepTitle
                                                  }
                                                  isFilled={this.state.isFilled}
                                                  isSkipped={
                                                    this.state.isSkipped
                                                  }
                                                  onNextStep={
                                                    this.handleNextStep
                                                  }
                                                  captcha_enabled={this.state.captcha_enabled}
                                                  link_form={this.state.link_form}
                                                />
                                              </div>
                                            ) : (
                                              TableLoader()
                                            )}
                                          </>
                                        )
                                      ) : null}
                                    </>
                                  ) : this.state.form_submitted === "3" ? (
                                    <div className="nk-block mt-4">
                                      <div className="nk-block-content nk-error-ld  text-center">
                                        <h3 className="nk-error-title">
                                          Form Unavailable
                                        </h3>
                                        <div className="alert alert-light text-dark">
                                          We are very sorry for inconvenience.
                                          It looks like you’re try to access a
                                          form that either has been expired or
                                          already submitted.
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                </>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                  {this.state.showIframeModal && (
                    <div
                      className="modal fade show"
                      style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.6)",
                        zIndex: 9999,
                      }}
                    >
                      <div
                        className="modal-dialog modal-dialog-centered modal-xl"
                        style={{
                          width: "90%",
                          maxWidth: "1400px",
                          position: "relative",
                        }}
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">
                              <em className="icon ni ni-monitor"></em> AI Agent
                              Sandbox
                            </h5>

                            <button
                              type="button"
                              className="close"
                              onClick={() => {
                                this.setState({ showIframeModal: false });
                                window.location.href = "/cp_forms";
                              }}
                              disabled={this.state.isStoppingAgent}
                            >
                              <em className="icon ni ni-cross"></em>
                            </button>
                          </div>
                          <div
                            className="modal-body"
                            style={{
                              height: "70vh",
                              padding: 0,
                              position: "relative",
                            }}
                          >
                            <iframe
                              src={this.state.iframeUrl}
                              title="AI Agent Sandbox"
                              style={{
                                width: "100%",
                                height: "100%",
                                border: "none",
                                borderRadius: "8px",
                              }}
                              allow="microphone; camera; clipboard-read; clipboard-write"
                            ></iframe>
                            {this.state.isStoppingAgent && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  backgroundColor: "rgba(255, 255, 255, 0.85)",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  zIndex: 10000,
                                  transition: "opacity 0.3s ease-in-out",
                                }}
                              >
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                  style={{ width: "3rem", height: "3rem" }}
                                />
                                <p className="mt-3 text-dark font-weight-bold">
                                  Stopping AI Agent… Please wait
                                </p>
                              </div>
                            )}
                          </div>
                          <div className="modal-footer">
                            <button
                              className="btn btn-danger"
                              onClick={this.stopAIAgent}
                              disabled={this.state.isStoppingAgent}
                            >
                              {this.state.isStoppingAgent ? (
                                <>
                                  <em className="icon ni ni-loader mr-1 animate-spin"></em>
                                  Stopping…
                                </>
                              ) : (
                                <>
                                  <em className="icon ni ni-power"></em> Stop
                                  Agent
                                </>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Modal for Preview Form */}
          <div className="modal fade" tabIndex="-1" id="modalPreviewForm">
            <div
              className="modal-dialog modal-lg modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={this.closeModal}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body">
                  {this.state.errorMessageSaveResponse !== "" ? (
                    <div
                      className="example-alert "
                      style={{ marginBottom: "15px" }}
                    >
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p>{this.state.errorMessageSaveResponse}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.successMessageSaveResponse !== "" ? (
                    <div
                      className="example-alert "
                      style={{ marginBottom: "15px" }}
                    >
                      <div className="alert alert-pro alert-success">
                        <div className="alert-text">
                          <h4>Success</h4>
                          <p>{this.state.successMessageSaveResponse}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="nk-modal">{this.state.modalContent}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OnboardingContent);
